export function clone(objectToClone: any) {
    return JSON.parse(JSON.stringify(objectToClone));
}

export const getParamValue = (currentValues: any[], newValue: any, key: string): string => {
    const index = currentValues.findIndex(c => c[key] === newValue[key])
    if (index === -1)
        currentValues.push(newValue);
    else
        currentValues.splice(index, 1);

    return currentValues.map(c => c[key]).join(",");
};